module.exports = __webpack_public_path__ + "img/2.2bb7741f.png";